import React, { useContext, useState, useEffect } from 'react';
import HomeNavBar from '../Shared/HomeNavBar/HomeNavBar';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../Shared/Footer/Footer';
import { AuthContext } from '../Context/AuthProvider/AuthProvider';
import items from '../../asset/FakeData/SideNavbarForAuthor.json';
import SideBarMain from '../Shared/SideNavbar/SideBarMain';
import './AuthorOutlet.css';

const AuthorOutlet = () => {
    const { reviewer } = useContext(AuthContext);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const location = useLocation();

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (!mobile) {
                setSidebarOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Close sidebar when route changes on mobile
    useEffect(() => {
        if (isMobile) {
            setSidebarOpen(false);
        }
    }, [location.pathname, isMobile]);

    // Handle body scroll when sidebar is open on mobile
    useEffect(() => {
        if (isMobile && sidebarOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [sidebarOpen, isMobile]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    return (
        <div>
            <HomeNavBar />
            
            {/* Mobile Sidebar Toggle Button */}
            {isMobile && (
                <button 
                    className="sidebar-toggle" 
                    onClick={toggleSidebar}
                    aria-label="Toggle Sidebar"
                >
                    <i className={sidebarOpen ? 'bi bi-x-lg' : 'bi bi-list'}></i>
                </button>
            )}

            {/* Sidebar Overlay for Mobile */}
            {isMobile && (
                <div 
                    className={`sidebar-overlay ${sidebarOpen ? 'overlay-open' : ''}`}
                    onClick={closeSidebar}
                ></div>
            )}

            {/* Sidebar */}
            <div className={`AuthorSidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
                <div className="sidebar">
                    {items.map((item, index) => (
                        <SideBarMain key={index} item={item} />
                    ))}
                </div>
            </div>
                
            {/* Main Content */}
            <div className="ReviewerMainComponent">
                <Outlet />
            </div>
        </div>
    );
};

export default AuthorOutlet;
